import { render, staticRenderFns } from "./wallet-type-form.vue?vue&type=template&id=6cacfc16"
import script from "./wallet-type-form.vue?vue&type=script&lang=js"
export * from "./wallet-type-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports